module.exports = __webpack_public_path__ + "static/img/中国东盟中心.994b321.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/中国东盟中心.jpg
// module id = UlQx
// module chunks = 1